export default "__VITE_ASSET__iDfhwhy3__"